

exports.__esModule = true;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoTokenizationInfoPageRoute', {
    path: 'tokenizationInfo',
    directive: _directive2['default'],
    titleContent: 'Tokenization Info Page',
    trackingData: {
        fptiState: 'tokenizationInfo'
    },

    children: []
});


_index.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-tokenization-info/route.js
// module id = ./pages/xo-tokenization-info/route.js
// module chunks = 1